<template>
		<div class="d-flex pdt-24" v-if="pointList" :class="pointList && pointList.type && pointList.type.value=='LOSE' ? '' :''"> 
			<div class="w-40 pdt-4">
					<img src="../../images/database-plus.png" alt="Earn" class="w-22 h-23" v-if="pointList && pointList.type && pointList.type.value=='EARN'" />
					<img src="../../images/database-minus.png" alt="Lose" class="w-22 h-23" v-if="pointList && pointList.type && pointList.type.value=='LOSE'" />
			</div>
			<div class="flex-grow-1 pdl-16 content-body">
					<div class="mgb-22">
							<!-- Add 포인트 설명 -->
							<div v-if="pointList.explain && pointList.explain.translate === '3063'">
									{{$t('3063')}}
							</div>
							<div v-else-if="pointList.explain && pointList.explain.translate === '3062'">
									{{$t('3063')}}
							</div>
							<div v-else>
								{{ handleLang(pointList.explain.translate) }}
							</div>

							<!-- 각 포인트 별 설명 -->
							<div class="t-body3 t-color-bodyGrayA font-r pdr-24 mgb-4 over-text" v-if="pointList.detailExplain">
								{{ pointList.detailExplain }}
							</div>

							<div class="t-body3 pdr-24 t-color-bodyGrayA font-r">
								{{$moment(pointList.assignTime).format('L')}}
							</div>
					</div>
			</div>
			<div class="t-subtitle4 font-rb t-line-h-22 font-b" v-if="pointList && pointList.type && pointList.type.value=='EARN'">+{{pointList.point}}</div>
			<div class="t-subtitle4 font-rb t-line-h-22 font-b" v-if="pointList && pointList.type && pointList.type.value=='LOSE'">-{{pointList.point}}</div>
		</div>
</template>

<script>
/**
 * 나의 학습 목록 아이템 컴포넌트(my learning main list item component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
export default {
	props: ["pointList","myStatus"],

	methods: {
		handleLang(code) {
			switch (code) {
				case "ui.membership.point.firstLogin":
					return this.$t("3008");

				case "ui.membership.point.login":
					return this.$t("3009");
				
				case "ui.membership.point.enterDegree":
					return this.$t("3010");
				
				case "ui.membership.point.completeDegree":
					return this.$t("3011");
				
				case "ui.membership.point.completeExam":
					return this.$t("3012");
				
				case "ui.membership.point.allSolveExam":
					return this.$t("3013");
				
				case "ui.membership.point.completeSurvey":
					return this.$t("3014");
				
				case "ui.membership.point.allSolveSurvey":
					return this.$t("3015");
				
				case "ui.membership.point.registerArticle":
					return this.$t("3016");
				
				case "ui.membership.point.registerComment":
					return this.$t("3017");
				
				case "ui.membership.point.registerLikes":
					return this.$t("3018");
				
				case "ui.membership.point.exitDegree":
					return this.$t("3019");
				
				case "ui.membership.point.incompleteDegree":
					return this.$t("3020");
				
				case "ui.membership.point.removeArticle":
					return this.$t("3021");
				
				case "ui.membership.point.removeComment":
					return this.$t("3022");
				
				case "ui.membership.point.removeLikes":
					return this.$t("3023");
				
				case "ui.membership.point.newBadge":
					return this.$t("3865");
				
				case "ui.membership.point.degreeReview":
					return this.$t("3889");

				case "ui.membership.point.satisfaction.survey.complete":
					return this.$t("3890");

				case "ui.membership.point.unassignByAdmin":
					return this.$t("3063");

				case "ui.membership.point.assignByAdmin":
					return this.$t("3062");

				case "ui.membership.point.resetByAdmin":
					return this.$t("3063");
					
				case "ui.membership.point.removeDegreeReview":
					return this.$t("3891");

				default:
					break;
			}
		}
	},
};
</script>

<style scoped>
.content-body {
	width: calc(100% - 100px)
}
.over-text {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
</style>